import {DELIVERY_MEMO, DeliveryMemoType, DeliveryRecipient, EntryMethod} from '@web/core/constants'

import {ZipCodeValidationStatus} from '../constant'
import {BaseAddressInfo, DeliveryInfoState, DeliveryMemo} from '../interfaces'

export const getInitialBaseAddressInfo = (): BaseAddressInfo => {
    return {
        hash: '',
        addressName: '',
        baseAddress: '',
        detailAddress: '',
        receiverName: '',
        telNo1: '010',
        telNo2: '',
        zipCode: '',
        buildingManagementNo: null,
        locationX: null,
        locationY: null,
        isRegistered: false,
        isPrimaryAddress: false,
        isRoadNameAddress: false,
    }
}

export const getInitialMemoInfo = () => {
    return {
        value: '',
        type: DELIVERY_MEMO.INITIAL,
    }
}

export const getInitialState = (): DeliveryInfoState => ({
    enabled: true,
    deliveryNothingOrder: false,
    virtualPhoneNumber: {
        used: false,
        onVirtualPhoneNumber: false,
        restrictedVirtualPhoneNumbers: [],
    },
    memo: {
        individuallyInput: getInitialMemoInfo(),
        particularInputByItemId: {},
        isParticularInput: false,
        saveAsDefaultMemo: false,
        list: [],
    },
    pickup: {
        location: {
            type: null,
            content: '',
        },
        entryMethod: {
            type: EntryMethod.LOBBY_PW,
            content: '',
        },
        alwaysUses: false,
    },
    selected: {
        addressInfo: null,
        recipient: DeliveryRecipient.NORMAL,
    },
    deprecatedZipCodes: [],
    hasArrivalGuaranteeProduct: false,
    hasOverseasDeliveryProduct: false,
    isDeliveryChangeable: true,
    deliveryModalCase: null,
    hasDefaultAddress: false,
    shouldOpenAddressBook: false,
    zipCodeValidation: {
        validateCase: null,
        status: ZipCodeValidationStatus.IDLE,
        validationFailType: null,
    },
})

export function convertZipCode(zipCode?: string) {
    return (zipCode ?? '').replace('-', '')
}

export type MemoOption = {
    /** 메모 타입 */
    type: DeliveryMemoType
    /** 메모 내용 */
    value: string
}

export const createMemoOptionList = (memoList: DeliveryMemo[]): MemoOption[] => {
    return [
        {
            type: DELIVERY_MEMO.NOTHING,
            value: '',
        },
        {
            type: DELIVERY_MEMO.WRITTEN,
            value: '',
        },
        ...memoList.map(({value, template}) => {
            return {
                type: template ? DELIVERY_MEMO.COMMON : DELIVERY_MEMO.WRITTEN,
                value,
            }
        }),
    ]
}
